import React, { useState, useEffect } from "react";
import { styled } from "@mui/material";
import { Icon } from "@iconify/react";
import { Typography } from "@mui/material";



/* =====================
   STYLED COMPONENTS
===================== */

const PageContainer = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: theme.theme_pallete.secondary_color || "#FAFAFA",
  paddingTop: "140px",
  paddingBottom: "80px",
}));

const ContentWrapper = styled("div")({
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "0 40px",
});

// const PageTitle = styled("h1")({
//   fontFamily: "Oswald",
//   fontSize: "48px",
//   fontWeight: 400,
//   textAlign: "center",
//   marginBottom: "24px",
//   marginTop: 0,
//   letterSpacing: "1px",
// });

// const PageDescription = styled("p")({
//   fontFamily: "system-ui, -apple-system, sans-serif",
//   fontSize: "16px",
//   lineHeight: "1.6",
//   color: "#666",
//   textAlign: "center",
//   maxWidth: "700px",
//   margin: "0 auto 60px",
//   padding: "0 20px",
// });

const SearchContainer = styled("div")({
  maxWidth: "600px",
  margin: "0 auto 60px",
  position: "relative",
});

const SearchInput = styled("input")({
  width: "100%",
  padding: "16px 50px 16px 20px",
  fontFamily: "Raleway",
  fontSize: "16px",
  border: "2px solid #E0E0E0",
  borderRadius: "4px",
  outline: "none",
  transition: "border-color 0.2s ease",
  
  "&:focus": {
    borderColor: "#333",
  },
  
  "&::placeholder": {
    color: "black",
  },
});

const SearchIcon = styled("div")({
  position: "absolute",
  right: "16px",
  top: "50%",
  transform: "translateY(-50%)",
  color: "#666",
  pointerEvents: "none",
});

const VideoGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
  gap: "40px",
  marginBottom: "60px",
  
  "@media (max-width: 768px)": {
    gridTemplateColumns: "1fr",
    gap: "30px",
  },
});

const VideoCard = styled("a")({
  textDecoration: "none",
  color: "inherit",
  display: "block",
  transition: "transform 0.3s ease",
  cursor: "pointer",
  
  "&:hover": {
    transform: "translateY(-8px)",
  },
});

const ThumbnailContainer = styled("div")({
  position: "relative",
  width: "100%",
  paddingBottom: "56.25%",
  backgroundColor: "#E0E0E0",
  borderRadius: "4px",
  overflow: "hidden",
  marginBottom: "16px",
});

const Thumbnail = styled("img")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

const PlayButton = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "68px",
  height: "48px",
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background-color 0.2s ease",
  
  "&:hover": {
    backgroundColor: "#FF0000",
  },
});

const VideoTitle = styled("h3")({
  fontFamily: "Oswald",
  fontSize: "18px",
  fontWeight: 400,
  marginBottom: "8px",
  letterSpacing: "0.5px",
  lineHeight: "1.4",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
});

const VideoDate = styled("p")({
  fontFamily: "Raleway",
  fontSize: "14px",
  color: "#666",
  margin: 0,
});

const PaginationContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  marginTop: "40px",
});

const PaginationButton = styled("button")(({ disabled }) => ({
  fontFamily: "Raleway",
  fontSize: "14px",
  letterSpacing: "1px",
  padding: "12px 24px",
  border: "2px solid #333",
  backgroundColor: disabled ? "#E0E0E0" : "transparent",
  color: disabled ? "#999" : "#333",
  cursor: disabled ? "not-allowed" : "pointer",
  borderRadius: "4px",
  transition: "all 0.2s ease",
  
  "&:hover": {
    backgroundColor: disabled ? "#E0E0E0" : "#333",
    color: disabled ? "#999" : "#fff",
  },
}));

const PageInfo = styled("span")({
  fontFamily: "Raleway",
  fontSize: "14px",
  letterSpacing: "1px",
  color: "#666",
});

const LoaderContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "400px",
  gap: "20px",
});

const Spinner = styled("div")({
  width: "50px",
  height: "50px",
  border: "4px solid #E0E0E0",
  borderTop: "4px solid #333",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
  
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
});

const LoaderText = styled("p")({
  fontFamily: "Oswald",
  fontSize: "16px",
  letterSpacing: "1px",
  color: "#666",
});

const ErrorMessage = styled("div")({
  textAlign: "center",
  padding: "40px",
  fontFamily: "raleway",
  fontSize: "16px",
  color: "#666",
});

const NoResults = styled("div")({
  textAlign: "center",
  padding: "60px 20px",
  fontFamily: "Oswald",
  fontSize: "18px",
  letterSpacing: "1px",
  color: "#666",
});

/* =====================
   COMPONENT
===================== */

const YouTubeVideos = () => {
  const [allVideos, setAllVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  
  const VIDEOS_PER_PAGE = 12;

  // Replace these with your actual values

 const API_KEY = "AIzaSyD5Mo-458TwhqCey9eeZwXWU9R36bF49dg";
  const CHANNEL_ID = "UCxG4a8jMRdcYUUk_5E2WC3w";


  useEffect(() => {
    fetchVideos();
  }, []);

  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredVideos(allVideos);
      setCurrentPage(1);
      return;
    }

    const query = searchQuery.toLowerCase();
    const filtered = allVideos.filter((video) =>
      video.snippet.title.toLowerCase().includes(query) ||
      video.snippet.description.toLowerCase().includes(query)
    );

    setFilteredVideos(filtered);
    setCurrentPage(1);
  }, [searchQuery, allVideos]);

  const fetchVideos = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=50&type=video`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch videos");
      }

      const data = await response.json();
      setAllVideos(data.items || []);
      setFilteredVideos(data.items || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Pagination logic
  const totalPages = Math.ceil(filteredVideos.length / VIDEOS_PER_PAGE);
  const startIndex = (currentPage - 1) * VIDEOS_PER_PAGE;
  const endIndex = startIndex + VIDEOS_PER_PAGE;
  const currentVideos = filteredVideos.slice(startIndex, endIndex);

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  if (loading) {
    return (
      <PageContainer>
        <ContentWrapper>
          {/* <PageTitle>MY VIDEOS</PageTitle> */}
          <LoaderContainer>
            <Spinner />
            <LoaderText style={{ color: "#666", fontSize: "16px", margin: 0, fontFamily: "Raleway" }}>Trying to load the videos for you...</LoaderText>
          </LoaderContainer>
        </ContentWrapper>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer>
        <ContentWrapper>
          {/* <PageTitle>MY VIDEOS</PageTitle> */}
          <ErrorMessage>
            Experiencing an issue: {error}
            <br />
            <br />
            Please check your internet connection or reload the page again.
          </ErrorMessage>
        </ContentWrapper>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <ContentWrapper>
         <Typography sx={{ mb: 4, fontSize: "20px" }}>
 I create YouTube content videos featuring professionals across the tech ecosystem, where we discuss innovation, career growth, and navigating transitions across different stages and roles. The conversations are practical and experience-driven, with the aim of helping viewers make more informed decisions about their careers.
If you find the sessions useful, feel free to like, comment, and <a href='https://www.youtube.com/channel/UCxG4a8jMRdcYUUk_5E2WC3w?app=desktop'> subscribe </a> &#10084;&#65039;.
         </Typography>  
        <SearchContainer>
          <SearchInput
            type="text"
            placeholder="Search by any topic or interests that comes to mind..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <SearchIcon>
            <Icon icon="mdi:magnify" style={{ fontSize: "24px" }} />
          </SearchIcon>
        </SearchContainer>

        {currentVideos.length === 0 ? (
          <NoResults>
            {searchQuery
              ? `I don’t have any video on "${searchQuery}" Can you try finding something else that interests you?`
              : "No videos available"}
          </NoResults>
        ) : (
          <>
            <VideoGrid>
              {currentVideos.map((video) => (
                <VideoCard
                  key={video.id.videoId}
                  href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ThumbnailContainer>
                    <Thumbnail
                      src={video.snippet.thumbnails.medium.url}
                      alt={video.snippet.title}
                    />
                    <PlayButton>
                      <Icon
                        icon="mdi:play"
                        style={{ fontSize: "32px", color: "white" }}
                      />
                    </PlayButton>
                  </ThumbnailContainer>
                  <VideoTitle>{video.snippet.title}</VideoTitle>
                  <VideoDate><b> {formatDate(video.snippet.publishedAt)} </b></VideoDate>
                </VideoCard>
              ))}
            </VideoGrid>

            {totalPages > 1 && (
              <PaginationContainer>
                <PaginationButton
                  onClick={goToPreviousPage}
                  disabled={currentPage === 1}
                >
                  <b>
                  PREVIOUS
                  </b>
                  
                </PaginationButton>
                
                <PageInfo>
                 <b>  PAGE {currentPage} OF {totalPages} </b>
                </PageInfo>
                
                <PaginationButton
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                >
                  <b>
                  NEXT
                  </b>
                  
                </PaginationButton>
              </PaginationContainer>
            )}
          </>
        )}
      </ContentWrapper>
    </PageContainer>
  );
};

export default YouTubeVideos;